import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import JSONLD from '@/components/feature/JSONLD';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '开云登录',
  url: 'https://www.kaiyun-login.com',
  description: '开云登录官方入口，提供安全、快速、稳定的登录体验。支持多设备一键开云登录，保障账户安全。',
  inLanguage: 'zh-CN',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '开云登录支持哪些登录方式？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '开云登录支持账号密码登录、手机验证码登录、邮箱验证码登录、扫码登录、指纹/面部识别登录等多种方式。',
      },
    },
    {
      '@type': 'Question',
      name: '如何保障我的账户安全？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '开云登录提供多重安全保障：双因素认证、异常登录实时检测、TLS 1.3加密传输、AES-256数据加密等。',
      },
    },
    {
      '@type': 'Question',
      name: '开云登录是否免费使用？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '开云登录基础版对个人用户完全免费，提供核心登录功能和基础安全保障。企业版提供高级功能。',
      },
    },
    {
      '@type': 'Question',
      name: '可以在多少台设备上同时登录？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '开云登录支持在多台设备上同时保持登录状态。您可以在账户设置中查看所有已登录设备。',
      },
    },
    {
      '@type': 'Question',
      name: '忘记密码如何找回？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过登录页面的忘记密码功能，使用绑定的手机号或邮箱接收验证码后重置密码。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <JSONLD data={websiteSchema} />
      <JSONLD data={faqSchema} />
      <SEOHead
        title="开云登录 - 官方入口安全快速登录 | 开云登录官网"
        description="开云登录官方入口，提供安全、快速、稳定的登录体验。支持多设备一键开云登录，保障账户安全，享受极速访问服务。立即使用开云登录，开启您的专属体验之旅。"
        keywords="开云登录,开云登录入口,开云官方登录,开云账号登录,开云平台登录,开云登录注册,开云安全登录"
        canonicalUrl="https://www.kaiyun-login.com/"
        ogTitle="开云登录 - 官方入口安全快速登录"
        ogDescription="开云登录官方入口，提供安全、快速、稳定的登录体验。支持多设备一键开云登录，保障账户安全，享受极速访问服务。"
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturesSection />
        <CategorySection />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}